import { format } from '@spx-portal/shared-utils';

import { $gt } from '@/common/appCtx';

/**
   * Table Columns
   */

const importTimeColumn = {
  get title() { return $gt('Import Time'); },
  dataIndex: 'import_time',
  width:200,
  key:'import_time',
  render: (value: number) => {
    return format(value);
  },
};

const userNameColumn = {
  get title() { return $gt('User Name'); },
  dataIndex: 'user_name',
  width:200,
  key:'user_name',
};

const importTypeColumn = {
  get title() { return $gt('Operation'); },
  dataIndex: 'import_type',
  width:150,
  key:'import_type',
};

enum ImportStautsEnum {
  Fail = 0,
  PartialSuccess = 1,
  Success = 2,
}

const importStatusColumn = {
  get title() { return $gt('Import Status'); },
  dataIndex: 'import_status',
  width:200,
  key:'import_status',
  render: (value: number) => {
    return ImportStautsEnum[value] ?? value;
  }
};

export const useFields = () => {
  const tableColumns = [
    importTimeColumn,
    userNameColumn,
    importTypeColumn,
    importStatusColumn,
  ];

  return {
    tableColumns,
  };
};
